import React, { createContext, useContext } from 'react';
import { useNotifications } from '../hooks/useNotifications';
import { SendPushNotificationCommand } from '../types';

interface NotificationContextType {
  sendNotification: (input: SendPushNotificationCommand) => Promise<any>;
  isLoading: boolean;
  error: Error | null;
}

const NotificationContext = createContext<NotificationContextType | undefined>(undefined);

interface NotificationProviderProps {
  children: React.ReactNode;
}

export function NotificationProvider({ children }: NotificationProviderProps) {
  const notificationState = useNotifications();

  return (
    <NotificationContext.Provider value={notificationState}>
      {children}
    </NotificationContext.Provider>
  );
}

export function useNotificationContext() {
  const context = useContext(NotificationContext);
  if (context === undefined) {
    throw new Error('useNotificationContext must be used within a NotificationProvider');
  }
  return context;
}
